"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks if a number is between a limit and returns the corrected, limited value
 * @param number the number that should be checked if it is between the limit of
 * @param min minimum
 * @param max maximum number
 */
var clampNumber = function (number, min, max) {
    return Math.min(max, Math.max(min, number));
};
exports.default = clampNumber;
//# sourceMappingURL=clampNumber.js.map